import i18n from '@/i18n';
import store from '@/store';
import dayjs from 'dayjs';
import S_contractorType from '@/service/api/v1/contractor_type';
import S_meetingTemplate from '@/service/api/v1/meetingTemplate';
import S_ContractorCustomedType from '@/service/api/v1/contractor_customed_type';
import H_factoryTag from '@/helpers/factoryTag';

export default {
  getFields(fieldTypes) {
    const resultFields = [];
    fieldTypes.forEach(type => {
      const tarField = this.getFilterField(type);
      resultFields.push(tarField);
    });
    return resultFields;
  },
  getFilterField(type){
    const {
      name,
      type: filterType,
      getItems,
      getDefaultVal,
      cols,
      smcols,
      isTitleHide,
      title,
      placeholder,
      defaultValue,
      leftBtnText,
      items,
      disableCancel = false,
    } = type;
    let field = {
      cols: cols ? cols : 3,
      smcols: smcols ? smcols : 12,
      name,
      type: filterType,
      getItems,
      getDefaultVal,
      placeholder: '選擇',
      disableCancel,
    };
    if (filterType === 'search') {
      field = {
        ...field,
        title: '搜尋',
        placeholder: placeholder ? placeholder : `${i18n.t('搜尋')}`,
        defaultValue: '',
      };
    } else if (filterType === 'avatar' || filterType === 'avatars') {
      field = {
        ...field,
        title: name === 'reviewer'
          ? '覆核者'
          : name === 'checker'
          ? '答題者'
          : name === 'principal'
          ? '被代理人'
          : name === 'agents'
          ? '代理人'
          : name === 'updatedUser'
          ? '更新者'
          : '管理者',
        placeholder: i18n.t('選擇'),
        defaultValue: filterType === 'avatar' ? null : [],
      };
    } else if (filterType === 'two-layer-dropdown') {
      if (name === 'systemSubclasses') {
        field = {
          ...field,
          title: '預設領域',
          placeholder: '選擇',
          btnIcon: 'icon-nav-add-audit',
          items: [],
          allSelectText: '全部',
          defaultValue: [],
        };
      }
      if (name === 'factorySystemClasses') {
        field = {
          ...field,
          title: '自訂領域',
          items: [],
          defaultValue: [],
          allSelectText: '全部',
        };
      }
    } else if (filterType === 'one-layer-dropdown') {
      if (name === 'factoryTags') {
        field = {
          ...field,
          title: '標籤',
          placeholder: '選擇',
          items: [],
          defaultValue: [],
          selectAll: false,
          hasSearch: true,
        };
      }
      if (name === 'guidelineStatus') {
        field = {
          ...field,
          title: '施行狀態',
          placeholder: '選擇',
          items: [],
          defaultValue: [],
          selectAll: false,
          hasSearch: false,
        };
      }
      if (name === 'hasUnreleased') {
        field = {
          ...field,
          title: '發布狀態',
          placeholder: '選擇',
          items: [
            {
              text: '發布',
              value: 0,
            },
            {
              text: '未發布',
              value: 1,
            },
          ],
          defaultValue: [],
          selectAll: false,
          hasSearch: false,
        };
      }
      if (name === 'convertStatus') {
        field = {
          ...field,
          title: '狀態',
          placeholder: '選擇',
          items: [
            {
              text: '處理中',
              value: 'PENDING,PROCESSING',
            },
            {
              text: '已完成',
              value: 'COMPLETE',
            },
            {
              text: '處理失敗',
              value: 'FAILED',
            },
          ],
          defaultValue: [],
          hasSearch: false,
        };
      }
      if (name === 'meetingTemplateType') {
        field = {
          ...field,
          title: '類型',
          placeholder: '選擇',
          items: [],
          defaultValue: [],
          getItems: async () => {
            const res = await S_meetingTemplate.indexType();
            return H_factoryTag.setItems(res);
          }
        };
      }
      if (name === 'meetingExportType') {
        field = {
          ...field,
          title: '類型',
          placeholder: '選擇',
          items: [
            {
              value: 'meeting',
              text: '議程',
            },
            {
              value: 'schedule',
              text: '時序表',
            },
          ],
          defaultValue: [],
        };
      }
    } else if (filterType === 'radio-dropdown') {
      if (name === 'template') {
        field = {
          ...field,
          title: '公版',
          placeholder: '選擇',
          items: [],
          defaultValue: null,
          hasSearch: true,
        };
      } else if (name === 'no_renew_template') {
        field = {
          ...field,
          title: '狀態',
          placeholder: '選擇',
          defaultValue: '0',
        };
      } else if (name === 'license_status') {
        field = {
          ...field,
          title: '狀態',
          placeholder: '選擇',
          defaultValue: '-1',
          items: [
            {
              id: '-1',
              textLabel: '全部',
            },
            {
              id: '0',
              textLabel: '逾期',
            },
            {
              id: '1',
              textLabel: '辦理中',
            },
            {
              id: '2',
              textLabel: '使用中',
            },
            {
              id: '3',
              textLabel: '已停用',
            },
          ],
        };
      } else if (name === 'order') {
        field = {
          ...field,
          title: '排序',
          placeholder: '選擇',
          defaultValue: 'created_at',
          items: [
            {
              id: 'created_at',
              textLabel: '依建立日期由近至遠',
            },
            {
              id: 'updated_at',
              textLabel: '依更新時間由近至遠',
            },
          ],
        };
      } else if (name === 'searchType') {
        field = {
          ...field,
          title: '搜尋種類',
          placeholder: '選擇',
          defaultValue: 'file',
          items: [
            {
              id: 'file',
              textLabel: '檔案標題',
            },
            {
              id: 'file_folder',
              textLabel: '資料夾名稱',
            },
          ],
        };
      } else if (name === 'locale') {
        const localeList = store.state.locale.locales;
        const userLocale = store.state.stone_auth.currentUser.locale;
        const defaultValue = userLocale !== null
          ? userLocale.id
          : localeList && localeList.length > 0
          ? localeList[0].id
          : null;
        field = {
          ...field,
          title: '語言',
          placeholder: '選擇語言',
          items: localeList.map(({ name, id }) => ({
            id,
            textLabel: name,
          })),
          defaultValue,
        };
      }
    } else if (filterType === 'date-duration') {
      field = {
        ...field,
        title: name === 'updatedAt'
          ? '更新日期'
          : '日期',
        placeholder: '選擇',
        defaultValue: {
          start: dayjs().subtract(3, 'months').startOf('day').format(),
          end: dayjs().startOf('day').format(),
        },
        leftBtnText: '重置',
      };
      if (leftBtnText) field.leftBtnText = leftBtnText;
    } else if (filterType === 'contractor-type') {
      field = {
        ...field,
        title: '承攬類別',
        placeholder: '選擇',
        items: [],
        defaultValue: [[],[]],
        getItems: async () => {
          const params = {
            order_by: 'sequence',
            order_way: 'asc',
            get_all: 1,
          };
          const [
            { data: templateContractorType },
            { data: customContractorType },
          ] = await Promise.all([
            S_contractorType.index({ params }),
            S_ContractorCustomedType.index({ params }),
          ]);
          const toItems = (rawType) =>
            (rawType || [])
              .filter(type => type.contractors_number !== undefined && type.contractors_number > 0)
              .map(type => ({
                value: type.id,
                text: type.name,
                contractorsNum: type.contractors_number,
              }));
          return [toItems(templateContractorType), toItems(customContractorType)];
        },
        getDefaultVal: (allTypeList) => allTypeList.map(type => type.map(type => type.value)),
      };
    }
    field = {
      ...field,
      title: isTitleHide
        ? ''
        : title
        ? title
        : field.title,
      defaultValue: defaultValue
        ? defaultValue
        : field.defaultValue,
      items: items
        ? items
        : field.items,
    }
    return field;
  },
  initState(filterFields, queryList) {
    const filterState = {};
    filterFields.forEach(field => {
      const query = this.setFilterStateFromQuery(field, queryList[field.name]);
      filterState[field.name] = query
        ? query
        : field.defaultValue !== undefined
        ? field.defaultValue
        : null;
    })
    return filterState;
  },
  setFilterStateFromQuery(filterField, queryValue) {
    if (!filterField || !queryValue) return null;
    if (filterField.type === 'one-layer-dropdown') {
      return queryValue.split(',');
    }
    if (
      filterField.type === 'two-layer-dropdown' &&
      (filterField.name === 'systemSubclasses' || filterField.name === 'factorySystemClasses')
    ) {
      return String(queryValue)
        .split(',')
        .filter(Boolean);
    }
    return null;
  },
}
